export default "__VITE_ASSET__Dq20QGwc__"